import type Task from '../schema/Task';

export interface GetTasksResponse {
    Value: Task[];
    errorResponse?: Error;
}

export function isGetTaskResponse(response: any): response is GetTasksResponse {
    return response?.Value;
}

export function getErrorFromObject(error: any): Error {
    if (error instanceof Error) {
        return error;
    } else {
        let errorMessage = null;
        try {
            errorMessage = JSON.stringify(error);
        } catch {
            errorMessage = '[getErrorFromObject]: Unable to parse Error Message';
        }
        return new Error(errorMessage);
    }
}
